import { BreadcrumbLabel } from '@app/navigation/BreadcrumbLabel';
import { useGetTraceByIdQuery } from '@features/investigations/api/files.api';

interface InvestigationFindingsBreadcrumbParams {
  traceId?: string;
}

export const InvestigationFindingsBreadcrumb = (params: InvestigationFindingsBreadcrumbParams) => {
  const traceId = params.traceId;
  const { data, isLoading } = useGetTraceByIdQuery(traceId ?? '', { skip: !traceId });

  return <BreadcrumbLabel label={data?.data?.traceName ?? 'Investigation Findings'} isLoading={isLoading} />;
};
